import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
  path: '/',
  redirect: '/index.html'
},
{
  path: '/',
  name: 'home',
  component: () => import('@/views/home/index'),
  children: [
    // 首页
    {
      path: '/index.html',
      name: 'index',
      meta: {
        "title": "计算机工程系-茂名职业技术学院",
        searchVisible: true
      },
      component: () => import('../views/index/index')
    },
    // 栏目页面
    {
      path: '/:column.htm',
      name: 'column',
      meta: {
        // "title": "栏目页面--茂名职业技术学院-计算机工程系",
        searchVisible: false  
      },
      component: () => import('@/views/column/index')
    },

    // 详情页  正文页
    {
      path: '/info/:cid/:aid.htm',
      name: 'info',
      component: () => import('@/views/details/details'),
      meta:{
        searchVisible: false
      }
    },
    // 搜索页
    {
      path:'search.htm',
      name:'search',
      component:()=>import('@/views/search/index'),
      meta:{
        searchVisible: false,
        "title": "内容搜索-计算机工程系-茂名职业技术学院",
      }
    }
  ],

},
]

const router = new VueRouter({
  routes,
  // mode:'history'
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router